import { client } from '..';
import {
  LinkMeParams,
  LinkMeResponse,
  MeResponse,
  OnBoardingChurchParams,
  OnBoardingParams,
  OnBoardingSecularParams
} from '../models/meModels';

export interface GetMeUserParams {
  firebaseId: string;
  onBoardingType?: string;
}

export const getMeUser = async (params: GetMeUserParams): Promise<MeResponse> => {
  const { data } = await client.post('/auth/user-onboarding', {
    firebaseId: params.firebaseId,
    onBoardingType: params.onBoardingType
  });
  return data;
};

export const linkMe = async ({
  firstName,
  lastName,
  firebaseId,
  role,
  phone
}: LinkMeParams): Promise<LinkMeResponse> => {
  const { data } = await client.post('/auth/link', { firstName, lastName, firebaseId, role, phone });
  return data;
};

export const onBoardingUpdate = async ({
  onBoardingId,
  userInterestOnDenomination,
  userInterestOnProgram,
  userInterestOnReligion,
  agreeEULA,
  skipPreferenceScreen,
  range,
  location,
  address
}: OnBoardingParams): Promise<any> => {
  const { data } = await client.patch(`/on-boarding/${onBoardingId}`, {
    userInterestOnDenomination,
    userInterestOnProgram,
    userInterestOnReligion,
    agreeEULA,
    skipPreferenceScreen,
    range,
    location,
    address
  });
  return data;
};

export const onBoardingUpdateChurch = async ({
  preferenceId,
  userInterestOnDenomination,
  userInterestOnProgram,
  userInterestOnReligion,
  skipPreferenceScreen,
  general,
  revenue,
  backgroundChecks,
  boardDirectors,
  pastors,
  totalSalaries,
  pL,
  partyAudit,
  impactStudy,
  salaries,
  landEquipments,
  fundraising,
  programs,
  lightRatingQuestions,
  isSetPreferenceScreen,
  isSetNotificationsScreen,
  isSetLocationScreen
}: OnBoardingChurchParams): Promise<any> => {
  const { data } = await client.patch(`/on-boarding/church/${preferenceId}`, {
    userInterestOnDenomination,
    userInterestOnProgram,
    userInterestOnReligion,
    skipPreferenceScreen,
    general,
    revenue,
    backgroundChecks,
    boardDirectors,
    pastors,
    totalSalaries,
    pL,
    partyAudit,
    impactStudy,
    salaries,
    landEquipments,
    fundraising,
    programs,
    lightRatingQuestions,
    isSetPreferenceScreen,
    isSetNotificationsScreen,
    isSetLocationScreen
  });
  return data;
};

export const onBoardingUpdateSecular = async ({
  preferenceId,
  userInterestOnProgram,
  skipPreferenceScreen,
  nineNintyForm,
  general,
  revenue,
  backgroundChecks,
  boardDirectors,
  pastors,
  totalSalaries,
  pL,
  partyAudit,
  impactStudy,
  salaries,
  landEquipments,
  fundraising,
  programs,
  lightRatingQuestions,
  isSetPreferenceScreen,
  isSetNotificationsScreen,
  isSetLocationScreen
}: OnBoardingSecularParams): Promise<any> => {
  const { data } = await client.patch(`/on-boarding/secular/${preferenceId}`, {
    userInterestOnProgram,
    skipPreferenceScreen,
    nineNintyForm,
    general,
    revenue,
    backgroundChecks,
    boardDirectors,
    pastors,
    totalSalaries,
    pL,
    partyAudit,
    impactStudy,
    salaries,
    landEquipments,
    fundraising,
    programs,
    lightRatingQuestions,
    isSetPreferenceScreen,
    isSetNotificationsScreen,
    isSetLocationScreen
  });
  return data;
};

export const getCities = async ({ city }: { city: string }): Promise<any> => {
  const { data } = await client.get(`/places/autocomplete/cities?input=${city}`);
  return data;
};

export const getAddress = async ({ address }: { address: string }): Promise<any> => {
  const { data } = await client.get(`/places/autocomplete?input=${address}`);
  return data;
};

export const getPlaces = async ({ placeId }: { placeId: string }): Promise<any> => {
  const { data } = await client.post(`/places/get`, { placeId });
  return data;
};
